import forOneApp from '../../../app/hoc/for-one-app';
import RichContentEditor from './rich-content-editor-lazy';
import RichContentEditorOneApp from './rich-content-editor-one-app-lazy';

export default forOneApp(RichContentEditorOneApp, RichContentEditor);
